exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".active {\n  color: red;\n}\n\n.hidden {\n  opacity: .3;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/nide/Code/3dissue/3d-issue-hubs-ui/src/app/manage-content/manage-content.component.css
// module id = ../../../../../src/app/manage-content/manage-content.component.css
// module chunks = main